import React from 'react'

import { QA } from '@hozana/tests/constants'

import { Cell } from 'elements/layout/Cell'
import { Row } from 'elements/layout/Row'

import { JoinButton, TJoinButtonProps } from 'modules/community/components/JoinButton'

export type TCommunitySubscriptionButtonsProps = {
  trackingSource: string
} & Pick<TJoinButtonProps, 'community'>

export const CommunitySubscriptionButtons: TFC<TCommunitySubscriptionButtonsProps> = ({
  community,
  trackingSource,
}) => (
  <Row align="middleCenter" gutter="10px" data-testid={QA.COMMUNITY_PAGE.ACTION_BUTTONS}>
    <Cell w={{ xs: 1, sm: 1 / 3, lg: 1 }}>
      <JoinButton
        w="100%"
        size="bigger"
        community={community}
        trackingSource={trackingSource}
        // No event origin here because it is already on the community's page
      >
        trans:community:words.i-subscribe
      </JoinButton>
    </Cell>
  </Row>
)
